import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class TipsService {
  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }
  /**
   * 
   * @param dataForm get token
   */
  getTips(token) {
    return this.http.get<any>(environment.url + '/Tips',
      { headers: this.headers.set('Authorization', token) }).pipe(retry(1), catchError(this.errorHandl));
  }

  /**
   * Control errores generico para todas las llamadas
   * @param error: Object
   */
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
